

/// <reference path="CoreEntityUpdatedBy.ts" />

// Generated class ChangelogAppSync_ManagedObject

class ChangelogAppSync_ManagedObject extends CoreEntityUpdatedBy
{

    // Property: error
    set error(value:string) {
        this.setValueForKey(value, 'error');
    }
    get error():string {
        return this.valueForKey('error');
    }
    set errorPrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'error');
    }
    get errorPrimitiveValue():string {
        return this.primitiveValueForKey('error');
    }

    // Property: status
    set status(value:number) {
        this.setValueForKey(value, 'status');
    }
    get status():number {
        return this.valueForKey('status');
    }
    set statusPrimitiveValue(value:number) {
        this.setPrimitiveValueForKey(value, 'status');
    }
    get statusPrimitiveValue():number {
        return this.primitiveValueForKey('status');
    }

    // Property: syncIndex
    set syncIndex(value:number) {
        this.setValueForKey(value, 'syncIndex');
    }
    get syncIndex():number {
        return this.valueForKey('syncIndex');
    }
    set syncIndexPrimitiveValue(value:number) {
        this.setPrimitiveValueForKey(value, 'syncIndex');
    }
    get syncIndexPrimitiveValue():number {
        return this.primitiveValueForKey('syncIndex');
    }
    // Relationship: changelog
    set changelog(value:Changelog) {
        this.setValueForKey(value, 'changelog');
    }
    get changelog():Changelog {
        return this.valueForKey('changelog') as Changelog;
    }
}
